// extracted by mini-css-extract-plugin
export default {"main":"styles_main__sWXfK","number":"styles_number__1p6m4","activeNumber":"styles_activeNumber__LOe2R"};